<template>
  <div class="compare-wrap">
    <div class="top-box">
      <el-radio-group v-model="selectedType" class="select-box" @change="onSelectedType">
        <el-radio-button class="w100" label="1">建筑能耗对比</el-radio-button>
<!--        <el-radio-button class="w100" label="2">分户能耗对比</el-radio-button>-->
        <el-radio-button class="w100" label="3">设备单耗对比</el-radio-button>
      </el-radio-group>
    </div>
    <el-row :gutter="5" v-show="selectedType == 1">
      <el-col :span="4" class="left-box">
        <corner-box class="box-element">
          <div class="left-item-box">
            <span style="margin-left: 24px">分部：</span>
            <el-select v-model="area" @change="getCategory" class="w170">
              <el-option v-for="item in areaList" :label="item.divisionName" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span>能源类型：</span>
            <el-select v-model="powerType" @change="getCategory" class="w170">
              <el-option v-for="item in powerTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span>能源分项：</span>
            <el-select v-model="powerCategory" @change="getBuildings" class="w170">
              <el-option v-for="item in powerCategoryList" :label="item.categoryName" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span style="margin-left: 24px">单位：</span>
            <el-select v-model="unit" class="w170">
              <el-option v-for="item in unitList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span>建筑筛选：</span>
            <el-tree
                :default-expanded-keys="treeList"
                :data="treeList"
                node-key="id"
                ref="tree"
                show-checkbox
                :props="defaultProps"
                :default-checked-keys="defaultCheckedTreeKey">
            </el-tree>
          </div>
        </corner-box>
      </el-col>
      <el-col :span="20">
        <el-row class="top-item-box">
          <span>时间周期：</span>
          <el-radio-group v-model="dateType" @change="changePeriod">
            <el-radio-button label="day">日</el-radio-button>
            <el-radio-button label="month">月</el-radio-button>
            <el-radio-button label="year">年</el-radio-button>
          </el-radio-group>
          <span>时间范围：</span>
          <el-date-picker
              v-model="startDate"
              :type="timeType"
              :format="timeFormat"
              :value-format="timeFormat"
              :picker-options="defaultSdate"
              :key="'start'+startDate"
              :clearable='false'
          ></el-date-picker>
          —
          <el-date-picker
              v-model="endDate"
              :type="timeType"
              :format="timeFormat"
              :value-format="timeFormat"
              :picker-options="defaultEdate"
              :key="'end'+endDate"
              :clearable='false'
          ></el-date-picker>
          <el-button @click="query">查询</el-button>
        </el-row>
        <el-row :gutter="10" class="top-bar">
          <el-col :span="12">
            <corner-box class="chart-box box-element">
              <div class=" box-title">建筑能耗总量对比（{{ titleCategory }}）</div>
              <div></div>
              <div class="tool fr">
                <button @click="download({title: '建筑能耗总量对比' ,selector:'#totalCompare'})">下载</button>
                <button @click="print({title: '建筑能耗总量对比' ,selector:'#totalCompare'})">打印</button>
              </div>
              <div id="totalCompare" class="chart-con" :style="{width: '100%'}"></div>
            </corner-box>
          </el-col>
          <el-col :span="12">
            <corner-box class="chart-box box-element">
              <div class="box-title">建筑单位面积能耗对比（{{ titleCategory }}）</div>
              <div class="tool fr">
                <button @click="download({title: '建筑单位面积能耗对比' ,selector:'#unitAreaCompare'})">下载</button>
                <button @click="print({title: '建筑单位面积能耗对比' ,selector:'#unitAreaCompare'})">打印</button>
              </div>
              <div id="unitAreaCompare" class="chart-con" :style="{width: '100%'}"></div>
            </corner-box>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <corner-box class="chart-box box-element">
              <div class="box-title">建筑人均能耗对比（{{ titleCategory }}）</div>
              <div class="tool fr">
                <button @click="download({title: '建筑人均能耗对比' ,selector:'#personCompare'})">下载</button>
                <button @click="print({title: '建筑人均能耗对比' ,selector:'#personCompare'})">打印</button>
              </div>
              <div id="personCompare" class="chart-con" :style="{width: '100%'}"></div>
            </corner-box>
          </el-col>
          <el-col :span="12">
            <corner-box class="chart-box box-element">
              <el-table :data="tableData" height="100%">
                <el-table-column label="区域名称" prop="division" width="80"></el-table-column>
                <el-table-column label="建筑名称" prop="buildingName" width="80"></el-table-column>
                <el-table-column label="建筑面积（㎡）" prop="buildingAcreage" width="80"></el-table-column>
                <el-table-column label="使用人数" prop="peopleNumber" width="70"></el-table-column>
                <el-table-column :label="'总用电量('+chartsUnit+')'" prop="totalPower"></el-table-column>
                <el-table-column :label="'单位面积用电量('+ chartsUnit+')'" prop="electricityConsumptionPerUnitArea"
                                 width="100"></el-table-column>
                <el-table-column :label="'人均用电量('+chartsUnit+')'" prop="perCapitaElectricityConsumption"
                                 width="85"></el-table-column>
              </el-table>
            </corner-box>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row :gutter="5" v-show="selectedType == 3">
      <el-col :span="6" class="left-box">
        <corner-box class="box-element">
          <div class="left-item-box">
            <span style="margin-left: 24px">分部：</span>
            <el-select v-model="divisionId" @change="getCategory1" class="w170">
              <el-option v-for="item in divisionListData" :label="item.divisionName" :value="item.id"
                         :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span>能源类型：</span>
            <el-select v-model="energyType"  class="w170">
              <el-option v-for="item in powerTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box">
            <span style="margin-left: 24px">单位：</span>
            <el-select v-model="unit1" class="w170">
              <el-option v-for="item in unitList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="left-item-box" style="height: 70%">
            <span>设备筛选：</span>
            <el-tree
                style="height: 95%; overflow-y: auto ;overflow-x: auto"
                :default-expand-all="true"
                :data="categoryListData"
                node-key="id"
                ref="tree1"
                show-checkbox
                :props="defaultProps"
                :default-checked-keys="defaultCheckedTreeKey1">
            </el-tree>
          </div>
        </corner-box>
      </el-col>
      <el-col :span="18">
        <el-row class="top-item-box">
          <span>时间周期：</span>
          <el-radio-group v-model="dateType1" @change="changePeriod1">
            <el-radio-button label="day">日</el-radio-button>
            <el-radio-button label="month">月</el-radio-button>
            <el-radio-button label="year">年</el-radio-button>
          </el-radio-group>
          <span>时间范围：</span>
          <el-date-picker
              v-model="startDate1"
              :type="timeType1"
              :format="timeFormat1"
              :value-format="timeFormat1"
              :picker-options="defaultSdate1"
              :key="'start'+startDate1"
              :clearable='false'
          ></el-date-picker>
          —
          <el-date-picker
              v-model="endDate1"
              :type="timeType1"
              :format="timeFormat1"
              :value-format="timeFormat1"
              :picker-options="defaultEdate1"
              :key="'end'+endDate1"
              :clearable='false'
          ></el-date-picker>
          <el-button @click="query1">查询</el-button>
        </el-row>
        <el-row style="margin-top: 20px;margin-bottom: 20px;margin-left: 10px">
          <corner-box class="box-element">
            <div style="display: flex; justify-content: space-around;color: #fff; padding: 20px">
              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">最高能耗</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.maxName}}</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.max}}&nbsp;&nbsp;{{chartsUnit1}}</p>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">最低能耗</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.minName}}</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.min}}&nbsp;&nbsp;{{chartsUnit1}}</p>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">平均能耗</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.ave}}&nbsp;&nbsp;{{chartsUnit1}}</p>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">统计设备数量</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.deviceNum}}</p>
              </div>
              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">高于平均值设备数量</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.aboveAveNum}}</p>
              </div>
              <div style="display: flex;flex-direction: column;align-items: center">
                <p style="color:#999; line-height: 25px;font-size: 14px">低于平均值设备数量</p>
                <p style="padding-top: 10px;line-height: 25px">{{deviceecdata.belowAveNum}}</p>
              </div>
            </div>
          </corner-box>
        </el-row>
        <el-row :gutter="16"  style="margin-left: 10px">
          <corner-box class="chart-box1 box-element">
            <div style="color: #fff; font-size: 18px; padding: 10px; display: inline-block">设备单耗对比（电）</div>
            <div class="tool fr" style="margin-top: 15px">
              <button @click="download({title: '设备单耗对比' ,selector:'#equipmentCompare'})">下载</button>
              <button @click="print({title: '设备单耗对比' ,selector:'#equipmentCompare'})">打印</button>
            </div>
            <div id="equipmentCompare" class="chart-con1" :style="{width: '100%'}"></div>
          </corner-box>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CornerBox from "@/components/cornerBox";
import {getSession} from '@/assets/js/tools/instruments';
import {addResize, removeResize} from "../../assets/js/tools/echartsResize";

var echarts = require('echarts');
export default {
  name: "buildingECCompare",
  components: {CornerBox},
  data() {
    return {
      totalCompare: "",
      unitAreaCompare: "",
      personCompare: "",
      selectedType: '1',
      area: '1',
      areaList: [],
      powerType: 'elec',
      powerTypeList: [
        {
          id: 'elec',
          name: '电'
        },
        {
          id: 'water',
          name: '水'
        },
        {
          id: 'gas',
          name: '气'
        }
      ],
      powerCategory: '0',
      powerCategoryList: [],
      unit: '1',
      unitList: [
        {
          id: '1',
          name: 'tce'
        },
        {
          id: '2',
          name: 'kW·h'
        }
      ],
      defaultCheckedTreeKey: [],
      defaultProps: {
        children: 'child',
        label: 'categoryName'
      },
      treeList: [],
      defaultSdate: {
        disabledDate: (time) => {
          return time.getTime() >= new Date(this.endDate).getTime() || time.getTime() < new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
        }
      },
      defaultEdate: {
        disabledDate: (time) => {
          return time.getTime() <= new Date(this.startDate).getTime() || time.getTime() > new Date().getTime()
        }
      },
      dateType: 'day',
      startDate: this.getTime(new Date(new Date() - 1000 * 60 * 60 * 24 * 30)),
      endDate: this.getTime(new Date()),
      timeType: 'date',
      timeFormat: 'yyyy-MM-dd',
      totalData: [],
      totalxAxis: [],
      totalAverage: 1000,
      areaData: [],
      areaxAxis: [],
      areaAverage: 100,
      personData: [],
      personxAxis: [],
      personAverage: 100,
      titleCategory: '全部',
      chartsUnit: 'tce',
      tableData: [],

      //设备单耗对比
      equipmentCompare: '',
      equipmentCompareInfo: ['最高能耗', '最低能耗', '平均能耗', '统计设备数量', '高于平均值设备数量', '低于平均值设备数量'],
      divisionListData:[], //分布数据
      categoryListData:[], //设备数据
      defaultCheckedTreeKey1:[],//默认选择 设备
      divisionId:'1', //分布id
      energyType:'elec',//能源类型
      categoryIds:[],// 分类id
      unit1:'1',// 单位(tce为1，kW-h 为2)
      chartsUnit1:'tce', //直线图显示 单位
      dateType1:'day', //周期,可以传year/month/day
      startDate1: this.getTime(new Date(new Date() - 1000 * 60 * 60 * 24 * 30)),
      endDate1: this.getTime(new Date()),
      timeFormat1: 'yyyy-MM-dd',
      timeType1: 'date',
      defaultSdate1: {
        disabledDate: (time) => {
          return time.getTime() >= new Date(this.endDate1).getTime() || time.getTime() < new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
        }
      },
      defaultEdate1: {
        disabledDate: (time) => {
          return time.getTime() <= new Date(this.startDate1).getTime() || time.getTime() > new Date().getTime()
        }
      },

      equipmentCompareData: [], //折线图数据
      equipmentCompareyAxis: 1000,
      ave:'',//平均值
      deviceecdata:{},//表格数据

    }
  },
  mounted() {
    this.initdata();

    //设备单耗
    this.divisionlist(); //获取分部下拉框
    this.categorylist();// 设备筛选下拉框(获取分类列表)
  },
  beforeDestroy() {
    removeResize(this.totalCompare)
    removeResize(this.unitAreaCompare)
    removeResize(this.personCompare)
    removeResize(this.equipmentCompare)

  },
  methods: {

    onSelectedType(val){
      if (val  == '3' ){
        this.query1()
      }
    },

    initdata() {
      this.$get('eccompare/initdata',[this.selectedType]).then((response) => {
        this.treeList = response.buildingList;
        this.defaultCheckedTreeKey = this.getTreeChild(response.buildingList);
        this.powerCategoryList = [{id: '0', categoryName: '全部'}].concat(response.categoryList);
        this.areaList = response.division;
        this.totalData = response.initData.totalPower.data;
        this.totalxAxis = response.initData.totalPower.xAxis;
        this.totalAverage = response.initData.totalPower.averageTotalPower;
        this.areaData = response.initData.electricityConsumptionPerUnitArea.data;
        this.areaxAxis = response.initData.electricityConsumptionPerUnitArea.xAxis;
        this.areaAverage = response.initData.electricityConsumptionPerUnitArea.averageElectricityConsumptionPerUnitArea;
        this.personData = response.initData.perCapitaElectricityConsumption.data;
        this.personxAxis = response.initData.perCapitaElectricityConsumption.xAxis;
        this.personAverage = response.initData.perCapitaElectricityConsumption.averagePerCapitaElectricityConsumption;
        this.tableData = response.initData.form
        this.initecharts();
      })
    },

    divisionlist(){
      this.$get('eccompare/divisionlist',).then((response) => {
        this.divisionListData = response
      })
    },

    categorylist(){
      this.$get('eccompare/categorylist',[this.divisionId,3]).then((response) => {
        this.categoryListData = response
        this.defaultCheckedTreeKey1 = this.getTreeChild(response);
      })
    },

    getCategory1() {
      this.categorylist()
    },


    getCategory() {
      this.$get('eccompare/getcategorytypelistbyenergytype', [this.area, this.powerType,this.selectedType]).then((response) => {
        if (response.length > 0) {
          this.powerCategoryList = [{id: '0', categoryName: '全部'}].concat(response);
          this.powerCategory = '0';
          this.getBuildings()
        } else {
          this.powerCategoryList = [];
          this.powerCategory = '';
          this.treeList = [];
        }
      })
    },
    getBuildings() {
      this.$get('eccompare/getbuildinglistbycategorytypelist', [this.area, this.powerType,this.selectedType, this.powerCategory,]).then((response) => {
        this.treeList = response;
      })
    },
    getTime(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();
      var M = month < 10 ? '0' + month : month;
      var D = day + 1 < 10 ? '0' + day : day;
      return year + '-' + M + '-' + D
    },
    //获取当前月格式
    getMonth(date) {
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var M = month < 10 ? '0' + month : month;
      return year + '-' + M
    },
    initecharts() {
      var $this = this
      this.totalCompare = echarts.init(document.getElementById('totalCompare'));
      this.totalCompare.setOption({
        color: ['#4472c4'],
        tooltip: {
          trigger: 'axis',
          formatter: function (par) {
            return par[0].axisValue + '：' + par[0].data + '<br/>' + (par[0].data - $this.totalAverage >= 0 ? '高于均值：' : '低于均值：') + Math.abs(par[0].data - $this.totalAverage).toFixed(2)
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          show: true,
          type: 'category',
          data: this.totalxAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            color: '#909aa2'
          },
        },
        yAxis: {
          type: 'value',
          show: true,
          name: '(' + this.chartsUnit + ')',
          nameLocation: 'start',
          nameTextStyle: {
            color: '#909aa2',
            align: 'right'
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#909aa2'
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 15,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: true,
                position: 'insideEndTop',
                formatter(par) {
                  return '均值：' + par.value
                }
              },
              lineStyle: {
                color: '#ef8b48',
                type: 'solid'
              },
              data: [
                {
                  yAxis: this.totalAverage,
                }
              ]
            },
            data: this.totalData
          }
        ]
      });
      addResize(this.totalCompare)
      this.unitAreaCompare = echarts.init(document.getElementById('unitAreaCompare'));
      this.unitAreaCompare.setOption({
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          formatter: function (par) {
            return par[0].axisValue + '：' + par[0].data + '<br/>' + (par[0].data - $this.areaAverage >= 0 ? '高于均值：' : '低于均值：') + Math.abs(par[0].data - $this.areaAverage).toFixed(2)
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          show: true,
          type: 'category',
          data: this.areaxAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            color: '#909aa2'
          },
        },
        yAxis: {
          type: 'value',
          show: true,
          name: '(' + this.chartsUnit + ')',
          nameLocation: 'start',
          nameTextStyle: {
            color: '#909aa2',
            align: 'right'
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#909aa2'
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            type: 'bar',
            barWidth: 15,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: true,
                position: 'insideEndTop',
                formatter(par) {
                  return '均值：' + par.value
                }
              },
              lineStyle: {
                color: '#ef8b48',
                type: 'solid'
              },
              data: [
                {
                  yAxis: this.areaAverage,
                }
              ]
            },
            data: this.areaData
          }
        ]
      });
      addResize(this.unitAreaCompare)
      this.personCompare = echarts.init(document.getElementById('personCompare'));
      this.personCompare.setOption({
        color: ['#70ab47'],
        tooltip: {
          trigger: 'axis',
          formatter: function (par) {
            return par[0].axisValue + '：' + par[0].data + '<br/>' + (par[0].data - $this.personAverage >= 0 ? '高于均值：' : '低于均值：') + Math.abs(par[0].data - $this.personAverage).toFixed(2)
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          show: true,
          type: 'category',
          data: this.personxAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            color: '#909aa2'
          },
        },
        yAxis: {
          type: 'value',
          show: true,
          name: '(' + this.chartsUnit + ')',
          nameLocation: 'start',
          nameTextStyle: {
            color: '#909aa2',
            align: 'right'
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#909aa2'
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: '直接访问',
            type: 'bar',
            barWidth: 15,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: true,
                position: 'insideEndTop',
                formatter(par) {
                  return '均值：' + par.value
                }
              },
              lineStyle: {
                color: '#ef8b48',
                type: 'solid'
              },
              data: [
                {
                  yAxis: this.personAverage,
                }
              ]
            },
            data: this.personData
          }
        ]
      });
      addResize(this.personCompare)
    },
    changePeriod(val) {
      this.startDate = '';
      this.endDate = '';
      if (val == 'year') {
        this.startDate = JSON.parse(getSession("projectInfo")).projectStartTime.substring(0, 4)
        this.endDate = new Date().getFullYear().toString()
        this.timeType = 'year';
        this.timeFormat = 'yyyy'
      } else if (val == 'month') {
        this.startDate = this.getMonth(new Date(new Date() - 1000 * 60 * 60 * 24 * 12 * 30))
        this.endDate = this.getMonth(new Date())
        this.timeType = 'month'
        this.timeFormat = 'yyyy-MM'
      } else {
        this.startDate = this.getTime(new Date(new Date() - 1000 * 60 * 60 * 24 * 30))
        this.endDate = this.getTime(new Date())
        this.timeType = 'date'
        this.timeFormat = 'yyyy-MM-dd'
      }
    },

    changePeriod1(val) {
      this.startDate1 = '';
      this.endDate1 = '';
      if (val == 'year') {
        this.startDate1 = JSON.parse(getSession("projectInfo")).projectStartTime.substring(0, 4)
        this.endDate1 = new Date().getFullYear().toString()
        this.timeType1 = 'year';
        this.timeFormat1 = 'yyyy'
      } else if (val == 'month') {
        this.startDate1 = this.getMonth(new Date(new Date() - 1000 * 60 * 60 * 24 * 12 * 30))
        this.endDate1 = this.getMonth(new Date())
        this.timeType1 = 'month'
        this.timeFormat1 = 'yyyy-MM'
      } else {
        this.startDate1 = this.getTime(new Date(new Date() - 1000 * 60 * 60 * 24 * 30))
        this.endDate1 = this.getTime(new Date())
        this.timeType1 = 'date'
        this.timeFormat1 = 'yyyy-MM-dd'
      }
    },


    getTreeChild(data) {
      let result = [];
      let rr = function (arr) {
        arr.forEach(function (item) {
          result.push(item.id);
        })
      }
      rr(data)
      return result
    },
    query() {
      if (this.area && this.powerType && this.powerCategory && this.$refs.tree.getCheckedKeys().length) {
        this.$get('eccompare/getbuildingeccomparedata', [
          this.area, this.powerType,this.selectedType, this.powerCategory, this.unit, this.$refs.tree.getCheckedKeys().join(','), this.dateType, this.startDate, this.endDate
        ]).then((response) => {
          this.totalData = response.totalPower.data;
          this.totalxAxis = response.totalPower.xAxis;
          this.totalAverage = response.totalPower.averageTotalPower;
          this.areaData = response.electricityConsumptionPerUnitArea.data;
          this.areaxAxis = response.electricityConsumptionPerUnitArea.xAxis;
          this.areaAverage = response.electricityConsumptionPerUnitArea.averageElectricityConsumptionPerUnitArea;
          this.personData = response.perCapitaElectricityConsumption.data;
          this.personxAxis = response.perCapitaElectricityConsumption.xAxis;
          this.personAverage = response.perCapitaElectricityConsumption.averagePerCapitaElectricityConsumption;
          this.tableData = response.form;
          this.chartsUnit = this.unitList.find(item => item.id == this.unit).name;
          this.initecharts();
          this.titleCategory = this.powerCategoryList.find(item => item.id == this.powerCategory).categoryName;
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请将查询条件选择完整！'
        })
      }
    },
    print(option) {
      this.printHtml({'htmlTitle': option.title, 'selector': option.selector, 'type': 'canvas'});
    },
    download(option) {
      this.getPdf({'htmlTitle': option.title, 'selector': option.selector});
    },

    query1() {
      if (this.$refs.tree1.getCheckedKeys().length) {
        this.$get('eccompare/getdeviceecdata', [
          this.divisionId, this.energyType,this.selectedType,  this.$refs.tree1.getCheckedKeys().join(','), this.unit1,this.dateType1, this.startDate1, this.endDate1
        ]).then((response) => {
          console.log(response,'responseresponseresponse');
          this.equipmentCompareyAxis = response.histogram.xAxis
          this.equipmentCompareData = response.histogram.data
          this.ave   = response.table.ave
          this.deviceecdata = response.table
          this.chartsUnit1 = this.unitList.find(item => item.id == this.unit1).name;
          this.echarts();
        })
      } else {
        this.$message({
          type: 'warning',
          message: '请勾选设备！'
        })
      }
    },
    echarts(){

      let $this = this
      this.equipmentCompare = echarts.init(document.getElementById('equipmentCompare'));
      this.equipmentCompare.setOption({
        color: ['#4472c4'],
        tooltip: {
          trigger: 'axis',
          formatter: function (par) {
            return par[0].axisValue + '：' + par[0].data + '<br/>' + (par[0].data - $this.ave >= 0 ? '高于均值：' : '低于均值：') + Math.abs(par[0].data - $this.ave).toFixed(2)
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          show: true,
          type: 'category',
          data: this.equipmentCompareyAxis,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            color: '#909aa2'
          },
        },
        yAxis: {
          type: 'value',
          show: true,
          name: '(' + this.chartsUnit1 + ')',
          nameLocation: 'start',
          nameTextStyle: {
            color: '#909aa2',
            align: 'right'
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#909aa2'
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.2
            }
          }
        },
        series: [
          {
            name: '直接访问',
            type: 'bar',
            barWidth: 15,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: true,
                position: 'insideEndTop',
                formatter(par) {
                  return '均值：' + par.value
                }
              },
              lineStyle: {
                color: '#ef8b48',
                type: 'solid'
              },
              data: [
                {
                  yAxis: this.ave,
                }
              ]
            },
            data: this.equipmentCompareData
          }
        ]
      });
      addResize(this.equipmentCompare)
    },

  }
}
</script>

<style scoped lang="scss">
.compare-wrap {
  padding: 1px 3px 1px 5px;

  .top-box {
    padding-left: 1px;
    padding-top: 10px;
    margin-bottom: 5px;
  }

  .left-box {
    .box-element {
      height: 735px;
      padding-left: 15px;
    }

    .left-item-box {
      margin-top: 20px;
      margin-left: 5px;
      color: $light;
    }
  }

  .top-item-box {
    color: $light;
    padding-left: 20px;
    margin-bottom: 5px;

    .el-radio-group {
      margin-right: 10px;
    }

    .el-button {
      margin-left: 10px;
    }
  }

  .top-bar {
    margin-bottom: 5px;
  }

  .chart-box {
    padding: 0;
    position: relative;
    height: 345px;

    .tool {
      button {
        padding: 7px 15px;
        margin-left: 10px;
        background-color: transparent;
        border: 1px solid #1384c5;
        border-radius: 3px;
        font-size: 12px;
        color: #fff;
        z-index: 500;
        box-shadow: inset 0 0 20px #054f79;
        cursor: pointer;
      }
    }

    .chart-con {
      width: 695px;
      height: 265px;
      clear: right;
    }
    .chart-con1 {
      width: 695px;
      height: 415px;
      clear: right;
    }
  }
  .chart-box1 {
    padding: 0;
    position: relative;
    height: 495px;

    .tool {
      button {
        padding: 7px 15px;
        margin-left: 10px;
        background-color: transparent;
        border: 1px solid #1384c5;
        border-radius: 3px;
        font-size: 12px;
        color: #fff;
        z-index: 500;
        box-shadow: inset 0 0 20px #054f79;
        cursor: pointer;
      }
    }

    .chart-con {
      width: 695px;
      height: 265px;
      clear: right;
    }
    .chart-con1 {
      width: 695px;
      height: 415px;
      clear: right;
    }
  }
}
@media screen and (width:3440px) and (height: 1440px )   {
  .compare-wrap {
    .left-box{
      .box-element{
        height: 1200px;
      }
    }
    .chart-box{
      height: 600px;
       .chart-con {
      width: 695px;
      height: 485px;
      clear: right;
    }
    }
  }
   
}
</style>
